import { createApp } from 'vue'
import App from './App.vue'

// import { getPokeData } from './services/api/pokeData.js'

// let toto = {}
// const foo = async () => {
//     toto = await getPokeData()
//     return toto;
// }
// foo()
// console.log(foo())

createApp(App).mount('#app')
